import config from "../config/config.json";
import { headers } from "./../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../APIHelpers/Responses";

export const folderManagementServices = {
  getFolderManagementData,
  addNewFolderManagement,
  updateFolderManagementData,
  deleteFolderManagementData
};

// Add New Folder
async function addNewFolderManagement(userData) {
  const response = await fetch(
    `${config.API_URL}addNewFolderManagement`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data)
  return data;
}

// Update Folder
async function updateFolderManagementData(userData) {
  const response = await fetch(
    `${config.API_URL}updateFolderManagement`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data)
  return data
}

// Delete Folder
async function deleteFolderManagementData(userData) {
  const response = await fetch(
    `${config.API_URL}deleteFolderManagementData`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data)
  return data
}

// Get Folder
async function getFolderManagementData() {
  const response = await fetch(
    `${config.API_URL}getFolderManagementData`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}